import { getCookie } from "@lululemon/ecom-core";

export const isUserLoggedIn = (req) => {
  const isLoggedIn = getCookie("lll_oidc_token", req);
  return Boolean(isLoggedIn);
};

export const canRefreshAuthSession = (req) => {
  const isLoggedIn = getCookie("lll_refresh_token", req);
  return Boolean(isLoggedIn);
};

export const hasCartScopeMismatch = (req) => {
  const hasAccessToken = isUserLoggedIn(req);
  if (hasAccessToken) return false;

  const assetCookieNames = ["lll-ngc-assets_US", "lll-ngc-assets_CA"];
  return assetCookieNames.some((cookieName) => {
    const assetsCookie = getCookie(cookieName, req, false);
    if (!assetsCookie) return false;

    try {
      const parsed = JSON.parse(atob(assetsCookie));
      return parsed?.scope === "loggedin";
    } catch {
      return false;
    }
  });
};
